import Api from 'src/api/Base'

class GetSpaceGroups extends Api {
  requestUrl = `/api/spaceGroup`
}

export default GetSpaceGroups
